<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">UNPAID BILLS</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">UNPAID BILLS</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Alert Messages -->
            <div class="row" v-if="alert.success || alert.failed || alert.info">
              <div class="col-12">
                <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.success = false"></button>
                </div>
                <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>Error!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.failed = false"></button>
                </div>
                <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                  <strong>Info!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.info = false"></button>
                </div>
              </div>
            </div>

            <!-- Main content -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- Header -->
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">All Raised Unpaid Bills</h4>
                      <div>
                        <button v-if="getRight('ARCHIVE BILLS')"
                                class="btn btn-warning me-2"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#archiveBillsModal">
                          <i class="mdi mdi-archive-outline font-size-16"></i>
                          <span class="d-md-inline ms-1">Archive Bills</span>
                        </button>
                        <a v-if="getRight('CREATE BILL')" @click="gotTo('new-bill')"
                           class="btn btn-primary" type="button">
                          <i class="mdi mdi-plus-circle-outline font-size-16"></i>
                          <span class="d-md-inline ms-1">Create A Bill</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <!-- Revenue Stream Filter -->
                      <div class="col-md-3">
                        <label class="form-label mb-1">Revenue Stream:</label>
                        <select @change="filterByStream($event)" class="form-select">
                          <option value="">All Streams</option>
                          <option v-for="stream in streams" :key="stream.id" :value="stream.incomeTypePrefix">
                            {{ stream.name }}
                          </option>
                        </select>
                      </div>

                      <!-- Search -->
                      <div class="col-md-9">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control" placeholder="Search...">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Location and Date Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-end">
                      <!-- Location Filters -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Sub County:</label>
                        <select class="form-select" v-model="subCounty" @change="getBillsPaginate()">
                          <option value="">All Sub Counties</option>
                          <option v-for="item in subCounties" :key="item.subCountyID" :value="item">
                            {{ item.subCountyName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Ward:</label>
                        <select class="form-select" v-model="ward" @change="getZones(ward.wardID, ward.wardName)">
                          <option value="">All Wards</option>
                          <option v-for="item in wards" :key="item.wardID" :value="item">
                            {{ item.wardName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Zone:</label>
                        <select class="form-select" v-model="zone" @change="getUsers(zone)">
                          <option value="">All Zones</option>
                          <option v-for="item in zones" :key="item.zone" :value="item.zone">
                            {{ item.zone }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Attendant:</label>
                        <select class="form-select" v-model="selectedUser" @change="getBillsPaginate()">
                          <option value="">All Attendants</option>
                          <option v-for="item in users" :key="item.idNo" :value="item.idNo">
                            {{ item.names }}
                          </option>
                        </select>
                      </div>

                      <!-- Date Filters -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">From:</label>
                        <input v-model="dateFrom" class="form-control" type="date">
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">To:</label>
                        <input v-model="dateTo" class="form-control" type="date">
                      </div>
                    </div>

                    <!-- Download Buttons -->
                    <div class="mt-3">
                      <div class="btn-group" role="group">
                        <!-- Download Current Page -->
                        <button v-if="getRight('DOWNLOAD UNPAID INVOICES')"
                                @click="downloadCurrentPage()"
                                type="button"
                                class="btn btn-success"
                                :disabled="billDetails.length === 0">
                          <i class="bx bxs-download font-size-16"></i>
                          <span class="ms-1">Current Page ({{ billDetails.length }})</span>
                        </button>

                        <!-- Download All Records with Progress -->
                        <button v-if="getRight('DOWNLOAD UNPAID INVOICES')"
                                @click="downloadAllRecords()"
                                type="button"
                                class="btn btn-primary"
                                :disabled="isDownloadingAll || summary.count === 0">
                          <span v-if="isDownloadingAll">
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Downloading...
                          </span>
                          <span v-else>
                            <i class="bx bx-cloud-download font-size-16"></i>
                            <span class="ms-1">Download All ({{ numberFormat(summary.count) }})</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th class="text-nowrap">NO.</th>
                          <th class="text-nowrap">Bill No</th>
                          <th class="text-nowrap" style="min-width: 200px;">Description</th>
                          <th class="text-nowrap">Location</th>
                          <th class="text-nowrap">Attendant</th>
                          <th class="text-nowrap text-end">Billed Amount</th>
                          <th class="text-nowrap text-end">Amount Paid</th>
                          <th class="text-nowrap text-end">Balance</th>
                          <th class="text-nowrap">Status</th>
                          <th class="text-nowrap">Date</th>
                          <th class="text-nowrap">Customer</th>
                          <th class="text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in billDetails" :key="index">
                          <td class="text-nowrap">{{ index + 1 }}</td>
                          <td class="text-nowrap">{{ item.billNo }}</td>
                          <td style="min-width: 200px;">
                            <div>
                              <strong>{{ item.description }}</strong>
                              <small class="text-muted d-block">({{ item.incomeTypeDescription }})</small>
                              <small class="text-muted d-block">{{ item.feeDescription }}</small>
                              <small class="text-muted d-block">{{ maskPhoneNumber(item.customers) }}</small>
                            </div>
                          </td>
                          <td class="text-nowrap">
                            <div>
                              <div>{{ item.subCountyName }}</div>
                              <small class="text-muted">{{ item.wardName }}</small>
                              <small class="text-muted d-block">{{ item.zone }}</small>
                            </div>
                          </td>
                          <td class="text-nowrap">{{ item.names }}</td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.detailAmount) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.receiptAmount) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.billBalance) }}</span>
                          </td>
                          <td>
                            <div class="d-flex align-items-center">
                                  <span class="badge bg-success text-uppercase me-2" v-if="item.status === 'PAID'">
                                    {{ item.status }}
                                  </span>
                              <span class="badge bg-danger text-uppercase me-2" v-else>
                                    UNPAID
                                  </span>

                              <button
                                      @click="checkPaymentStatus(item)"
                                      class="btn btn-outline-success btn-sm"
                                      :disabled="item.isCheckingPayment">
                                <i v-if="!item.isCheckingPayment" class="bx bx-money"></i>
                                <div v-else class="spinner-border spinner-border-sm" role="status">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                                <small class="ms-1">Check</small>
                              </button>

                            </div>
                          </td>
                          <td class="text-nowrap">{{ item.dateCreated }}</td>
                          <td class="text-nowrap">{{ item.customerName }}</td>
                          <td class="text-nowrap">
                            <div class="d-flex">
                              <button @click="getBill(item.billNo)"
                                      class="btn btn-primary btn-sm me-2"
                                      data-bs-toggle="modal"
                                      data-bs-target="#billDetailModal">
                                View
                              </button>
                              <div class="dropdown">
                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                  <i class="bx bx-dots-vertical"></i>
                                </button>
                                <ul class="dropdown-menu">
                                  <li><a class="dropdown-item" href="javascript: void(0);"><i class="mdi mdi-printer me-2"></i>Print</a></li>
                                  <li><a class="dropdown-item" href="javascript: void(0);"><i class="mdi mdi-email me-2"></i>Email Reminder</a></li>
                                  <li><a class="dropdown-item" href="javascript: void(0);"><i class="mdi mdi-chat me-2"></i>SMS Reminder</a></li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-dark">
                        <tr>
                          <th colspan="5" class="text-end">{{ billDetails.length }} Bills</th>
                          <th class="text-end">{{ totalDetailAmount }}</th>
                          <th class="text-end">{{ totalReceiptAmount }}</th>
                          <th class="text-end">{{ totalBillBalance }}</th>
                          <th colspan="4"></th>
                        </tr>
                        </tfoot>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="text-center p-5">
                        <div class="spinner-border text-info mb-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <h4>Loading Data</h4>
                        <p>We are fetching the data for you. Please wait...</p>
                      </div>

                      <!-- No Results -->
                      <div v-if="billDetails.length < 1 && !loading" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Results To Show</h4>
                        <p>Sorry, we could not find any results that match your search or filter criteria.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="card-footer bg-white">
                    <nav class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="me-3">Rows Per Page</span>
                        <select class="form-select w-auto" v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                          <option value="150">150 Rows</option>
                          <option value="200">200 Rows</option>
                        </select>
                      </div>

                      <ul class="pagination mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="prevPage" :disabled="currentPage === 1">Previous</button>
                        </li>
                        <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                            class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <button v-else class="page-link" @click="goToPage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Download Progress Modal with Pause/Resume and Time Estimation -->
        <div class="modal fade" id="downloadProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-primary text-white">
                <h5 class="modal-title text-white">
                  <i class="bx bxs-download me-2"></i>Downloading All Records
                </h5>
              </div>
              <div class="modal-body">
                <div class="text-center mb-3">
                  <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status" v-if="!downloadPaused">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div v-else class="mb-3">
                    <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                  </div>
                  <h5 v-if="!downloadPaused">Please wait while we download your records...</h5>
                  <h5 v-else class="text-warning">Download Paused</h5>

                  <!-- Estimated Time Remaining -->
                  <div v-if="downloadProgress.estimatedTimeRemaining && !downloadPaused" class="mt-2">
                    <p class="text-muted mb-1">
                      <i class="bx bx-time-five me-1"></i>
                      <strong>{{ formatTimeRemaining(downloadProgress.estimatedTimeRemaining) }}</strong> remaining
                    </p>
                    <small class="text-muted">
                      Average speed: {{ downloadProgress.averageSpeed }} records/sec
                    </small>
                  </div>

                  <p class="text-muted mt-2">{{ downloadPaused ? 'You can resume or cancel the download.' : 'This may take several minutes depending on the amount of data.' }}</p>
                </div>

                <div class="progress mb-3" style="height: 25px;">
                  <div
                      class="progress-bar progress-bar-striped"
                      :class="{'progress-bar-animated': !downloadPaused, 'bg-warning': downloadPaused}"
                      role="progressbar"
                      :style="{ width: downloadProgress.percentage + '%' }"
                      :aria-valuenow="downloadProgress.percentage"
                      aria-valuemin="0"
                      aria-valuemax="100">
                    {{ downloadProgress.percentage }}%
                  </div>
                </div>

                <div class="d-flex justify-content-between text-muted small mb-3">
                  <span>Page {{ downloadProgress.current }} of {{ downloadProgress.total }}</span>
                  <span>{{ downloadProgress.records }} / {{ numberFormat(downloadProgress.totalRecords) }} records</span>
                </div>

                <!-- Error Display -->
                <div v-if="downloadError" class="alert alert-danger d-flex align-items-center" role="alert">
                  <i class="bx bx-error-circle me-2"></i>
                  <div class="flex-grow-1">
                    <strong>Error:</strong> {{ downloadError }}
                    <br>
                    <small>You can retry from where it stopped or cancel the download.</small>
                  </div>
                </div>

                <!-- Retry Count Display -->
                <div v-if="downloadRetryCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>Retry attempt {{ downloadRetryCount }} of 3</small>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex gap-2 justify-content-center mb-3">
                  <button
                      v-if="!downloadPaused && !downloadError"
                      @click="pauseDownload"
                      class="btn btn-warning btn-sm">
                    <i class="bx bx-pause me-1"></i>Pause
                  </button>
                  <button
                      v-if="downloadPaused || downloadError"
                      @click="resumeDownload"
                      class="btn btn-success btn-sm">
                    <i class="bx bx-play me-1"></i>Resume
                  </button>
                  <button
                      @click="cancelDownload"
                      class="btn btn-danger btn-sm">
                    <i class="bx bx-x me-1"></i>Cancel
                  </button>
                </div>

                <div class="alert alert-info d-flex align-items-center" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>{{ downloadPaused ? 'Download is paused. Your progress has been saved.' : 'Please do not close this window or navigate away.' }}</small>
                </div>

                <!-- Download Statistics -->
                <div v-if="downloadProgress.records > 0" class="mt-3 pt-3 border-top">
                  <div class="row text-center">
                    <div class="col-4">
                      <small class="text-muted d-block">Downloaded</small>
                      <strong>{{ numberFormat(downloadProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Remaining</small>
                      <strong>{{ numberFormat(downloadProgress.totalRecords - downloadProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Success Rate</small>
                      <strong>{{ getSuccessRate() }}%</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bill Detail Modal Component -->
        <BillDetailModal
            :billDetail="billDetail"
            :billInfo="billInfo"
            :billNo="billNo"
            @print-bill="printBill"
            @open-waiver="openWaiverModal"
        />

        <!-- Waiver Modal Component -->
        <WaiverModal
            ref="waiverModal"
            :billDetail="billDetail"
            :billInfoItem="billInfoItem"
            :type="type"
            :sessionPhoneNumber="sessionPhoneNumber"
            @submit-waiver="submitWaiver"
        />

        <!-- Payment Found Modal Component -->
        <PaymentFoundModal
            :pendingPayment="pendingPayment"
            :processingPayment="processingPayment"
            @process-payment="processPayment"
        />

        <!-- Archive Bills Modal Component -->
        <ArchiveBillsModal
            :streams="streams"
            @bills-archived="handleBillsArchived"
            @bills-restored="handleBillsRestored"
            @view-archived-bill="viewArchivedBill"
        />

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, executeDownload, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import BillDetailModal from "@/components/invoices/modals/BillDetailModal.vue";
import WaiverModal from "@/components/invoices/modals/WaiverModal.vue";
import PaymentFoundModal from "@/components/invoices/modals/PaymentFoundModal.vue";
import ArchiveBillsModal from "@/components/invoices/modals/ArchiveBillsModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "UnpaidBills",
  components: {
    NavigationBar,
    BillDetailModal,
    WaiverModal,
    PaymentFoundModal,
    ArchiveBillsModal
  },
  data() {
    return {
      download: 'Download',
      search: '',
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,

      // Filters
      dateFrom: '',
      dateTo: '',
      selectedStream: '',

      // Data
      billDetails: [],
      billInfo: [],
      billDetail: {},
      billInfoItem: {},
      billNo: '',

      // Location data
      subCounties: [],
      wards: [],
      zones: [],
      users: [],
      subCounty: '',
      ward: '',
      zone: '',
      selectedUser: '',

      // Revenue streams
      streams: [],

      // Modal data
      type: '',
      sessionPhoneNumber: '',
      pendingPayment: null,
      processingPayment: false,

      // Summary
      summary: { count: 0, total: 0 },

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: '',

      // Download All functionality with pause/resume and time estimation
      isDownloadingAll: false,
      downloadPaused: false,
      downloadCancelled: false,
      downloadError: null,
      downloadRetryCount: 0,
      maxRetries: 3,
      downloadProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      },
      allRecordsData: [],
      downloadState: {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      }
    }
  },
  computed: {
    totalReceiptAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, item) => sum + parseInt(item.receiptAmount || 0), 0));
    },
    totalBillBalance() {
      return this.formatPrice(this.billDetails.reduce((sum, item) => sum + parseInt(item.billBalance || 0), 0));
    },
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, item) => sum + parseInt(item.detailAmount || 0), 0));
    }
  },
  watch: {
    pageSize() {
      this.getBillsPaginate();
      this.totalPages = Math.ceil(this.summary.count / this.pageSize);
      this.currentPage = 1;
    },
    search() {
      this.getBillsPaginate();
    },
    subCounty() {
      this.getWards();
      this.getBillsPaginate();
    },
    ward() {
      this.getBillsPaginate();
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getBillsPaginate();
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getBillsPaginate();
      }
    }
  },
  mounted() {
    this.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber");
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');

    this.getAvailableStreams();
    this.getSubCounties();
    this.getBillsPaginate();
    this.menuAccess();
  },
  methods: {
    getRight,

    // Utility methods
    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value);
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    // Format time remaining in human-readable format
    formatTimeRemaining(seconds) {
      if (!seconds || seconds <= 0) return 'Calculating...';

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      if (hours > 0) {
        return `${hours}h ${minutes}m ${secs}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      } else {
        return `${secs}s`;
      }
    },

    // Calculate estimated time remaining
    calculateEstimatedTime() {
      if (!this.downloadProgress.startTime || this.downloadProgress.current === 0) {
        return;
      }

      const elapsedTime = (Date.now() - this.downloadProgress.startTime) / 1000;
      const recordsDownloaded = this.downloadProgress.records;
      const remainingRecords = this.downloadProgress.totalRecords - recordsDownloaded;

      if (recordsDownloaded > 0 && elapsedTime > 0) {
        const averageSpeed = recordsDownloaded / elapsedTime;
        this.downloadProgress.averageSpeed = averageSpeed.toFixed(2);

        const estimatedTimeRemaining = remainingRecords / averageSpeed;
        this.downloadProgress.estimatedTimeRemaining = estimatedTimeRemaining;
      }
    },

    // Get Success Rate
    getSuccessRate() {
      if (this.downloadProgress.total === 0) return 100;
      const successfulPages = this.downloadProgress.current - this.downloadRetryCount;
      return Math.round((successfulPages / this.downloadProgress.total) * 100);
    },

    // Pause Download
    pauseDownload() {
      this.downloadPaused = true;
      console.log('Download paused at page:', this.downloadState.currentPage);
    },

    // Resume Download
    async resumeDownload() {
      this.downloadPaused = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;

      console.log('Resuming download from page:', this.downloadState.currentPage + 1);

      await this.continueDownload();
    },

    // Cancel Download
    cancelDownload() {
      const confirmed = confirm('Are you sure you want to cancel the download? All progress will be lost.');

      if (confirmed) {
        this.downloadCancelled = true;
        this.closeDownloadModal();
      }
    },

    // Close Download Modal
    closeDownloadModal() {
      const modalElement = document.getElementById('downloadProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Reset state
      this.isDownloadingAll = false;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];
      this.downloadProgress = {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };
      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      };
    },

    gotTo(route) {
      router.push(route);
    },

    // Download Current Page (Client-side CSV generation) - WITHOUT "Receipted By"
    downloadCurrentPage() {
      if (this.billDetails.length === 0) {
        this.alert.info = true;
        this.message = 'No data available to download';
        return;
      }

      try {
        const csv = this.generateCSV(this.billDetails);

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `Unpaid_Bills_Page_${this.currentPage}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.alert.success = true;
        this.message = `Successfully downloaded ${this.billDetails.length} records from current page`;
      } catch (error) {
        console.error('Download error:', error);
        this.alert.failed = true;
        this.message = 'Failed to download data: ' + error.message;
      }
    },

    // Generate CSV from data array - WITHOUT "Receipted By" column
    generateCSV(data) {
      if (!data || data.length === 0) return '';

      // Define CSV headers - REMOVED "Receipted By"
      const headers = [
        'NO.',
        'Bill No',
        'Description',
        'Income Type',
        'Fee Description',
        'Customer',
        'Sub County',
        'Ward',
        'Zone',
        'Attendant',
        'Billed Amount',
        'Amount Paid',
        'Balance',
        'Status',
        'Date Created',
        'Customer Name'
      ];

      let csv = headers.join(',') + '\n';

      data.forEach((item, index) => {
        const row = [
          index + 1,
          this.escapeCSV(item.billNo),
          this.escapeCSV(item.description),
          this.escapeCSV(item.incomeTypeDescription),
          this.escapeCSV(item.feeDescription),
          this.escapeCSV(item.customers),
          this.escapeCSV(item.subCountyName),
          this.escapeCSV(item.wardName),
          this.escapeCSV(item.zone),
          this.escapeCSV(item.names),
          item.detailAmount || 0,
          item.receiptAmount || 0,
          item.billBalance || 0,
          item.status || 'UNPAID',
          this.escapeCSV(item.dateCreated),
          this.escapeCSV(item.customerName)
        ];
        csv += row.join(',') + '\n';
      });

      return csv;
    },

    // Escape CSV values
    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return '"' + stringValue.replace(/"/g, '""') + '"';
      }
      return stringValue;
    },

    // Download All Records with Pause/Resume/Retry and Time Estimation
    async downloadAllRecords() {
      if (!this.dateFrom || !this.dateTo) {
        this.alert.info = true;
        this.message = 'Please select date range before downloading';
        return;
      }

      const isConfirmed = confirm(
          `You are about to download all ${this.numberFormat(this.summary.count)} records from ${this.dateFrom} to ${this.dateTo}. This may take several minutes. Do you want to continue?`
      );

      if (!isConfirmed) return;

      this.isDownloadingAll = true;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];

      const batchSize = 1000;
      const totalRecords = this.summary.count;
      const totalPages = Math.ceil(totalRecords / batchSize);

      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: batchSize,
        totalPages: totalPages,
        accumulatedData: []
      };

      this.downloadProgress = {
        current: 0,
        total: totalPages,
        percentage: 0,
        records: 0,
        totalRecords: totalRecords,
        startTime: Date.now(),
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };

      const modalElement = document.getElementById('downloadProgressModal');
      const progressModal = new bootstrap.Modal(modalElement);
      progressModal.show();

      await this.continueDownload();
    },

    // Continue Download (used by both initial download and resume)
    async continueDownload() {
      try {
        const startPage = this.downloadState.currentPage + 1;
        const totalPages = this.downloadState.totalPages;

        for (let page = startPage; page <= totalPages; page++) {
          if (this.downloadPaused) {
            console.log('Download paused, waiting for resume...');
            return;
          }

          if (this.downloadCancelled) {
            console.log('Download cancelled by user');
            return;
          }

          try {
            this.downloadState.currentPage = page;
            this.downloadProgress.current = page;
            this.downloadProgress.percentage = Math.round((page / totalPages) * 100);

            const pageData = await this.fetchBillsPageWithRetry(page, this.downloadState.batchSize);

            if (pageData && pageData.length > 0) {
              this.downloadState.accumulatedData = [...this.downloadState.accumulatedData, ...pageData];
              this.allRecordsData = this.downloadState.accumulatedData;
              this.downloadProgress.records = this.allRecordsData.length;

              this.calculateEstimatedTime();
            }

            this.downloadRetryCount = 0;
            this.downloadError = null;

            await this.delay(50);

          } catch (error) {
            console.error(`Error fetching page ${page}:`, error);
            this.downloadError = error.message;
            this.downloadPaused = true;
            return;
          }
        }

        await this.finalizeDownload();

      } catch (error) {
        console.error('Download error:', error);
        this.downloadError = error.message;
        this.downloadPaused = true;
      }
    },

    // Fetch Bills Page with Retry Logic
    async fetchBillsPageWithRetry(page, rowsPerPage, retryCount = 0) {
      try {
        const data = new FormData();
        data.append("function", "getBillsPaginate");
        data.append("page", page);
        data.append("rows_per_page", rowsPerPage);
        data.append("status", "UNPAID");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("keyword", this.search);
        data.append("subCountyID", this.subCounty?.subCountyID || '');
        data.append("wardID", this.ward?.wardID || '');
        data.append("zone", this.zone);
        data.append("idNo", this.selectedUser);
        data.append("incomeTypePrefix", this.selectedStream);

        const res = await execute(data, biller);

        if (res.data.success) {
          return res.data.data.billDetails || [];
        } else {
          throw new Error(res.data.message || 'Failed to fetch page data');
        }
      } catch (error) {
        if (retryCount < this.maxRetries) {
          this.downloadRetryCount = retryCount + 1;
          console.log(`Retry ${this.downloadRetryCount} for page ${page}`);

          const waitTime = Math.pow(2, retryCount) * 1000;
          await this.delay(waitTime);

          return this.fetchBillsPageWithRetry(page, rowsPerPage, retryCount + 1);
        } else {
          throw new Error(`Failed after ${this.maxRetries} retries: ${error.message}`);
        }
      }
    },

    // Finalize Download
    async finalizeDownload() {
      if (this.allRecordsData.length > 0) {
        const csv = this.generateCSV(this.allRecordsData);

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const fileName = `All_Unpaid_Bills_${this.dateFrom}_to_${this.dateTo}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`;

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        await this.delay(500);

        this.alert.success = true;
        this.message = `Successfully downloaded ${this.allRecordsData.length} records!`;

        this.closeDownloadModal();
      } else {
        this.alert.info = true;
        this.message = 'No records found to download';
        this.closeDownloadModal();
      }
    },

    // Delay helper function
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // API methods
    async getAvailableStreams() {
      try {
        const data = new FormData();
        data.append("function", "getAvailableStreams");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.streams = res.data.data.streams;
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    filterByStream(event) {
      this.selectedStream = event.target.value;
      this.getBillsPaginate();
    },

    async getBillsPaginate() {
      try {
        this.billDetails = [];
        this.loading = true;

        const data = new FormData();
        data.append("function", "getBillsPaginate");
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);
        data.append("status", "UNPAID");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("keyword", this.search);
        data.append("subCountyID", this.subCounty?.subCountyID || '');
        data.append("wardID", this.ward?.wardID || '');
        data.append("zone", this.zone);
        data.append("idNo", this.selectedUser);
        data.append("incomeTypePrefix", this.selectedStream);

        const res = await execute(data, biller);
        this.loading = false;

        if (res.data.success) {
          this.billDetails = res.data.data.billDetails.map(item => ({
            ...item,
            isCheckingPayment: false
          }));
          this.summary = res.data.data.summary;
          this.totalPages = Math.ceil(this.summary.count / this.pageSize);
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.loading = false;
        this.message = e.message;
      }
    },

    async getSubCounties() {
      try {
        const data = new FormData();
        data.append("function", "getSubCounty");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getWards() {
      try {
        this.wards = [];
        this.ward = '';

        if (!this.subCounty?.subCountyID) return;

        const data = new FormData();
        data.append("function", "getWards");
        data.append("subCountyID", this.subCounty.subCountyID);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.wards = res.data.data.wards;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getZones(wardID, wardName) {
      try {
        this.zones = [];

        if (wardName) {
          this.getBillsPaginate();
        }

        if (!wardID) return;

        const data = new FormData();
        data.append("function", "getZones");
        data.append("wardID", wardID);

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.zones = res.data.data.zones;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getUsers(zone) {
      try {
        this.users = [];

        if (zone) {
          this.getBillsPaginate();
        }

        const data = new FormData();
        data.append("function", "getUsers");
        data.append("search", zone || '');

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.users = res.data.data.users;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getBill(billNo) {
      try {
        this.billNo = billNo;

        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", billNo);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.billInfo = res.data.data.billInfo;
          this.billDetail = res.data.data.billDetails;
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async checkPaymentStatus(item) {
      try {
        item.isCheckingPayment = true;

        const data = new FormData();
        data.append("function", "checkPaymentStatus");
        data.append("billNo", item.billNo);

        const res = await execute(data, biller);
        item.isCheckingPayment = false;

        if ((res.data.success || res.data.message === "Found") &&
            res.data.data?.paymentDetails?.length > 0) {
          this.showPaymentFoundModal(item, res.data.data.paymentDetails);
        } else {
          this.showNoPaymentFoundMessage();
        }
      } catch (e) {
        item.isCheckingPayment = false;
        this.message = e.message;
        this.alert.failed = true;
      }
    },

    showPaymentFoundModal(item, paymentDetails) {
      this.pendingPayment = {
        billItem: item,
        paymentDetails: paymentDetails
      };

      const modalElement = document.getElementById('paymentFoundModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    showNoPaymentFoundMessage() {
      this.message = "No pending payments found for this bill.";
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 3000);
    },

    async processPayment(payment) {
      try {
        this.processingPayment = payment.id;

        const data = new FormData();
        data.append("function", "processPayment");
        data.append("billNo", this.pendingPayment.billItem.billNo);
        data.append("paymentId", payment.id);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));

        const res = await execute(data, biller);
        this.processingPayment = false;

        if (res.data.success) {
          this.pendingPayment.paymentDetails = this.pendingPayment.paymentDetails.filter(p => p.id !== payment.id);

          if (this.pendingPayment.paymentDetails.length === 0) {
            const modalElement = document.getElementById('paymentFoundModal');
            if (modalElement) {
              const bootstrapModal = bootstrap.Modal.getInstance(modalElement);
              if (bootstrapModal) {
                bootstrapModal.hide();
              }
            }
          }

          this.message = "Payment processed successfully!";
          this.alert.success = true;
          this.getBillsPaginate();
        } else {
          this.message = res.data.message;
          this.alert.failed = true;
        }
      } catch (e) {
        this.processingPayment = false;
        this.message = e.message;
        this.alert.failed = true;
      }
    },

    openWaiverModal(item, type) {
      this.type = type;
      this.billInfoItem = item;

      const billModal = document.getElementById('billDetailModal');
      if (billModal) {
        const bootstrapModal = bootstrap.Modal.getInstance(billModal);
        if (bootstrapModal) {
          bootstrapModal.hide();
        }
      }

      setTimeout(() => {
        const waiverModal = new bootstrap.Modal(document.getElementById('waiverModal'));
        waiverModal.show();
      }, 300);
    },

    async submitWaiver(waiverData) {
      try {
        const data = new FormData();
        data.append("function", "submitWaiver");
        data.append("id", this.billInfoItem.id);
        data.append("billNo", this.billInfoItem.billNo);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("reason", waiverData.reason);
        data.append("type", this.type);

        const res = await execute(data, biller);

        const waiverModal = this.$refs.waiverModal;

        if (res.data.success) {
          if (waiverModal) {
            waiverModal.showSuccess();
          }

          this.message = "Waiver submitted successfully!";
          this.alert.success = true;

          this.getBillsPaginate();

          setTimeout(() => {
            this.alert.success = false;
            this.message = '';
          }, 3000);
        } else {
          if (waiverModal) {
            waiverModal.showError(res.data.message);
          }

          this.message = res.data.message || "Failed to submit waiver";
          this.alert.failed = true;
        }
      } catch (e) {
        const waiverModal = this.$refs.waiverModal;
        if (waiverModal) {
          waiverModal.showError(e.message);
        }

        this.message = e.message;
        this.alert.failed = true;
      }
    },

    printBill() {
      localStorage['params'] = JSON.stringify({
        billNo: this.billDetail.billNo
      });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "SBP Unpaid Bills");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    },

    // Pagination methods
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getBillsPaginate();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getBillsPaginate();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getBillsPaginate();
      }
    },

    // Archive-related methods
    handleBillsArchived() {
      this.getBillsPaginate();
      this.message = "Bills have been successfully archived";
      this.alert.success = true;

      setTimeout(() => {
        this.alert.success = false;
        this.message = '';
      }, 3000);
    },

    handleBillsRestored() {
      this.getBillsPaginate();
      this.message = "Bills have been successfully restored";
      this.alert.success = true;

      setTimeout(() => {
        this.alert.success = false;
        this.message = '';
      }, 3000);
    },

    viewArchivedBill(bill) {
      this.billDetail = bill;
      this.billInfo = [];
      this.billNo = bill.billNo;

      const archiveModal = document.getElementById('archiveBillsModal');
      if (archiveModal) {
        const bootstrapModal = bootstrap.Modal.getInstance(archiveModal);
        if (bootstrapModal) {
          bootstrapModal.hide();
        }
      }

      const billModal = new bootstrap.Modal(document.getElementById('billDetailModal'));
      billModal.show();
    }
  }
}
</script>

<style scoped>
.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.spinner-border-sm {
  width: 0.875rem;
  height: 0.875rem;
}

.btn-group .btn {
  white-space: nowrap;
}

.btn-group .btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Progress modal styling */
#downloadProgressModal .modal-body {
  padding: 2rem;
}

#downloadProgressModal .progress {
  background-color: #e9ecef;
}

#downloadProgressModal .progress-bar {
  font-weight: 600;
  font-size: 0.875rem;
}

/* Pause icon animation */
.bx-pause-circle {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Time remaining display */
.text-muted strong {
  color: #495057;
  font-weight: 600;
}
</style>